import React, { Component } from 'react';
import './Stream.scss';

class Stream extends Component {
    render() {
        return (
            <div className={`Stream`}>
                <div className={'stream-container'}>
                    <div className={'stream-header'}>
                        {`Watch now for free`}
                    </div>
                    <div className={'stream-text'}>
                        {`TEDxPortland is happening now -- don't miss a moment! We are live streaming the entire day in HD, for free. View from our partner, below.`}
                    </div>
                    <div className={'stream-buttons'}>
                        {/* <div className="button">
                            <img src={require('../../assets/oregonlive-logo.svg')} />
                        </div> */}
                        <div className="button" onClick={() => { window.open('https://livestream.com/accounts/26687643/events/8651658', '_blank') }}>
                            <img src={require('../../assets/kgw8-logo.svg')} />
                        </div>
                    </div>
                    <div className={'stream-footer'}>
                        {`Special thanks to our partners at`}<br />
                        {`the Oregonian Media Group and KGW.com.`}<br />
                    </div>
                </div>
            </div>
        );
    }
}

export default Stream; 